import {lorem, parseHex, formatValue, gri, shi, overall, blues, distance, angle, isGPUBlacklisted} from "../Utils";
import { OFFSCREEN_X, OFFSCREEN_Y, MOBILE_WIDTH, MAX_WIDTH, NO_ALIAS, BLACKLIST_SPRITE_SCALE, ASSETS, GRI_BREAKS, SHI_BREAKS, INDEX_LABELS} from "../Constants";
import {getWidth, getHeight} from '../Utils';
import * as d3 from "d3";

/* Use generators? */

export default class Layout {
	constructor(type="pop", slice=Infinity, nodes, count, model, width, height, spriteWidth, dim, offset_x=0, offset_y= 0, order=undefined) {
			this.nested = nodes;
			this.type = type;
			this.model = model;
			this._width = getWidth();
			this._height = getHeight();
			this.width = width;
			this.height = height;
			this.dim = dim;
			this.slice = slice;
			this.alternate = document.querySelector('#map').classList.contains('step-99');
			this.scale = document.createDocumentFragment();
			this.no_alias = isGPUBlacklisted() || NO_ALIAS;
			this.spriteWidth = spriteWidth;
			this.coordinates = new Array(count);
			this.labels = document.createDocumentFragment();
			this.nested.sort(function(a,b){  return d3.descending(a.values.length, b.values.length);});
			this.offset_x = offset_x;
			this.offset_y = offset_y;
			this.max_size = this._width/this._height > 2  ? Math.min(this._width, this._height, MAX_WIDTH) : Math.min(this._width, MAX_WIDTH);
			this.order = order;
			this.precision = (d) => d < 1e7 ? 1 : d < 5e7 ? 2 : d < 5e8 ? 3 : 4;
			if (slice < Infinity){
				this.nested = this.nested.slice(0,slice);
			}
			if ( type != "demo") {
				this.nested.sort((a,b) => d3.descending(this.model.get(a.key, type), this.model.get(b.key, type)));
			} else {
				this.nested.sort((a,b) => d3.descending(this.model.get(a.key, "shi"), this.model.get(b.key, "shi")));
			}
			this.layout();
			this.x_force = d3.forceX( d => this._coordinates_x(d.id)).strength(0);
			this.y_force = d3.forceY( d => this._coordinates_y(d.id)).strength(0);

	}
	_coordinates_x(id, offset=true) {
		return typeof this.coordinates[id] == 'undefined' ? OFFSCREEN_X : this.coordinates[id].x + ( offset ? this.offset_x : 0);
	}
	_coordinates_y(id, offset=true) {
		return typeof this.coordinates[id] == 'undefined' ? OFFSCREEN_Y : this.coordinates[id].y + ( offset ? this.offset_y : 0);
	}

	addLabel(id, _class, width, left, top, text, extra_style=``) {
		const s = document.createElement('span');
		s.setAttribute('id', `${id}`);
		s.setAttribute('class', `${_class}`);
		s.setAttribute('style', `height:12px;width:${width}px;left:${left}px;top:${top}px;${extra_style};`);
		s.setAttribute('data-top', `${top}`);
		s.textContent =  `${text}`;
		this.labels.appendChild(s);
	}

	getMargin() {
		return this._width < MOBILE_WIDTH ? 15 : this._width/this._height > 1.8 ? Math.abs(Math.ceil((this.max_size/2  - this.gridDim)/2)) * 1.8 : Math.ceil((this.max_size/2  - this.gridDim)/2) * 1.8;
	}

	layout() {
		let type = this.type;
		let dim = this.alternate ? this.dim : this.dim;
		let tile_spacing = this.no_alias ? -.2  : this.spriteWidth/7.5;
		let w = this.spriteWidth + tile_spacing //* 3/5 + 1;
		let rows = 5;
		this.gridCell = dim * w;
		let columns = Math.ceil(Math.min(this.nested.length, this.slice)/rows);
		let margin = (dim * w)/(rows-1.75);
		this.gridDim = rows * (dim * w) + (rows - 1) * margin;
		let init_margin = this.getMargin();
		let x = init_margin;
		let y = init_margin * (this._width/this._height > 1.8 ? .5 : .9);
		if (~['shi', 'gri'].indexOf(this.type)) {
			this.breaks = this.type == 'gri' ? GRI_BREAKS : SHI_BREAKS;
			this.x_scale = d3.scaleLinear().domain([0,10]).range([0, this.width * .93]);
			this.x_axis = d3.axisBottom(this.x_scale).tickValues([].concat(...this.breaks, 10)).tickFormat(d3.format(".1f"));
			this.svg = d3.select(this.scale).append("svg")
				.attr("width", this.max_size)
				.attr("height",this.height + 100)
				.append("svg:g")
				.attr("transform", `translate(${init_margin},0)`);
			for(let i = 0; i < INDEX_LABELS.length; i++ ) {
				this.svg.append("svg:text")
						.attr("class", "grid-label")
						.attr("x", this.x_scale((i == 0 ? this.breaks[i]/2 :
							 i == INDEX_LABELS.length - 1 ? (10 - this.breaks[i - 1])/2 + this.breaks[i - 1]:
							 (this.breaks[i] - this.breaks[i - 1])/2 + this.breaks[i-1]
						 )))
						.attr("y",this.height +  45 + 16)
						.style("text-anchor", "middle")
						.style("color", "#aaa")
						.text(`${INDEX_LABELS[i]}${ this._width < MOBILE_WIDTH ? `` : ` ${this.type}`}`);
			}
			this.svg_x_axis = this.svg.append("svg:g")
				.attr("class", "x axis")
				.attr("transform", `translate(0,${this.height + 45})`)
				.call(this.x_axis)
				.attr("class", `${this.type}`)
				.style("color", "#aaa");
		}
		if (typeof this.order == "undefined") {
			for( let i = 0; i < rows * columns; i++ ) {
				if (typeof this.nested[i] == 'undefined') return;
				if (i > 0) {
					if ( i % rows == 0) {
						 x = init_margin;
						 y += (dim * w) + margin;
					 } else {
						 x += (dim * w) + margin;
					 }
				 }
				let x1 = 0;
				let y1 = 0;
				let demo = [];
				let demo_per = [];
				let demo_iterator = 0;
				let demo_break = 0;
				let cum = 0;
				let pop = 0;
			 	if (type == "demo") {
			 		demo = d3.entries(this.model.getDemo([this.nested[i].key])).sort(function(a,b){return d3.descending(a.value, b.value)});
				 	pop = this.model.getPopulation(this.nested[i].key, '2010');
					demo_per = [...demo.map(d=> +(d.value/pop).toFixed(this.precision(pop)))];
			 	}
				 for ( let j = 0; j < this.nested[i].values.length; j++ ) {
			 		if (type == "demo") {
			 			if (j == 0 ) {
			 				y1 += w;
							this.addLabel(`label--${this.nested[i].key}--${demo[demo_iterator].key}`, `label small ${type}`, dim * w, x, y+y1,`${demo[demo_iterator].key} <span>(${Math.round(demo[demo_iterator].value / pop * 100) < 1 ? `< 1`: Math.round(demo[demo_iterator].value / pop * 100)}%)</span>`);
			 				y1 += w;
			 			}
						if (demo_break % dim == 0) {
								x1 = 0;
								y1 += w;
						}
			 			if ( +(j / this.nested[i].values.length).toFixed(this.precision(pop)) >= demo_per[demo_iterator] + cum  && demo_iterator < demo.length - 1) {
			 				demo_iterator++;
			 				y1 += w;
							this.addLabel(`label--${this.nested[i].key}--${demo[demo_iterator].key}`, `label small ${type}`, dim * w, x, y+y1, `${demo[demo_iterator].key} <span>(${Math.round(demo[demo_iterator].value / pop * 100) < 1 ? `< 1`: Math.round(demo[demo_iterator].value / pop * 100)}%)</span>`);
			 				x1 = 0;
			 				y1 += w * 2;
							cum += demo_per[demo_iterator - 1];
							demo_break = 1;
			 			} else {
							demo_break++;
						}
			 		}
					let e = this.nested[i].values[j];
					 if (j % dim == 0 && type != "demo" ){
						 x1 = 0;
						 y1 += w;
					 }
					 this.coordinates[e.id] = {x: x + x1, y: y + y1};
					 x1 += w;
				 }
				 if (demo_iterator < demo.length - 1) {
				 	y1 += w;
				 	for ( let j = demo_iterator + 1; j < demo.length; j++ ) {
						this.addLabel(`label--${this.nested[i].key}--${demo[j].key}`, `label small ${type}`, dim * w, x, y+y1, `${demo[j].key} <span>(${Math.round(demo[j].value / pop * 100) < 1 ? `< 1`: Math.round(demo[j].value / pop * 100)}%)</span>`);
		 				y1 += w * 3;
				 	}
				 }
				 if (i < rows * rows || (type == 'demo' && this.slice == Infinity) ) {
					this.addLabel(`label--${this.nested[i].key}`, `label`, dim * w, x, y, `${this.type != 'demo' ? this.model.getAbbrev(this.nested[i].key) : this.model.getName(this.nested[i].key)}`);
				 	if (type != "demo") {
						this.addLabel(`label--${this.nested[i].key}--value`, `label ${type}`, dim * w, x, y+y1, `<span class="value">${type == "pop" ? formatValue(this.model.getPopulation(this.nested[i].key)).replace('G', 'B') : this.model.get(this.nested[i].key, this.type).toFixed(2) }</span>`);
					}
				}
			}
		} else {
				for(let i=0; i < this.order.length; i++) {
					if (i > 0) {
						if ( i % rows == 0) {
							 x = init_margin;
							 y += (dim * w) + margin;
						 } else {
							 x += (dim * w) + margin;
						 }
					 }
					if (this.order[i] !== null ){
						let x1 = 0;
						let y1 = 0;
						let demo = [];
						let demo_per = [];
						let demo_iterator = 0;
						let demo_break = 0;
						let cum = 0;
						let pop = 0;
						let country = this.nested.filter((d) => d.key == this.order[i])[0];
						if (type == "demo") {
							demo = d3.entries(this.model.getDemo([country.key])).sort(function(a,b){return d3.descending(a.value, b.value)});
							pop = this.model.getPopulation(country.key, '2010');
							demo_per = [...demo.map(d=> +(d.value/pop).toFixed(this.precision(pop)))];
						}
						for ( let j = 0; j < country.values.length; j++ ) {
							if (type == "demo") {
								if (j == 0 ) {
									y1 += w;
									this.addLabel(`label--${country.key}--${demo[demo_iterator].key}`, `label small ${type}`, dim * w, x, y+ y1, `${demo[demo_iterator].key} <span>(${Math.round(demo[demo_iterator].value / pop * 100) < 1 ? `< 1`: Math.round(demo[demo_iterator].value / pop * 100)}%)</span>`);
									y1 += w;
								}
								if (demo_break % dim == 0) {
										x1 = 0;
										y1 += w;
								}
								if ( +(j / country.values.length).toFixed(this.precision(pop)) >= demo_per[demo_iterator] + cum && demo_iterator < demo.length - 1) {
									demo_iterator++;
									y1 += w;
									this.addLabel(`label--${country.key}--${demo[demo_iterator].key}`, `label small ${type}`, dim * w, x, y + y1, `${demo[demo_iterator].key} <span>(${Math.round(demo[demo_iterator].value / pop * 100) < 1 ? `< 1`: Math.round(demo[demo_iterator].value / pop * 100)}%)</span>` );
									x1 = 0;
									y1 += w *  (this._width < MOBILE_WIDTH && this.alternate ? 5 : this.alternate ? 3 : 2);
									cum += demo_per[demo_iterator - 1];
									demo_break = 1;
								} else {
									demo_break++;
								}
							}
							let e = country.values[j];
							 if (j % dim == 0 && type != "demo" ){
								 x1 = 0;
								 y1 += w;
							 }
							 this.coordinates[e.id] = {x: x + x1, y: y + y1};
							 x1 += w;
						 }
						 if (demo_iterator < demo.length - 1) {
						 	y1 += w;
						 	for ( let j = demo_iterator + 1; j < demo.length; j++ ) {
								this.addLabel(`label--${country.key}--${demo[j].key}`, `label small ${type}`, dim * w, x, y+y1, `${demo[j].key} <span>(${Math.round(demo[j].value / pop * 100) < 1 ? `< 1`: Math.round(demo[j].value / pop * 100)}%)</span>`);
				 				y1 += w * (this.alternate && this._width < MOBILE_WIDTH ? 6 : 3);
						 	}
						 }
						 if (i < rows * rows || (type == 'demo' && this.slice == Infinity) ) {
							this.addLabel(`label--${country.key}`, `label`, dim * (w * (this._width < MOBILE_WIDTH ? 1.5 : 2)), x, y,  `${this.type != 'demo' || (this.alternate && this._width < MOBILE_WIDTH) ? this.model.getAbbrev(country.key) : this.model.getName(country.key)}` );
						 	if (type != "demo") {
								this.addLabel(`label--${this.nested[i].key}--value`, `label ${type}`, dim * w, x, y+y1, `<span class="value">${type == "pop" ? formatValue(this.model.getPopulation(country.key)).replace('G', 'B') : this.model.get(country.key, this.type).toFixed(2) }</span>` );

							}
						}
					}
				}
			}
		}
}
